import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '@services/app.service';
import { UtilityService } from '@services/utility.service';
import { Observable, of, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailComponent } from '@pages/email/email.component';
import { ApiService } from '@services/api.service';
import { NavigationEnd, Router } from '@angular/router';
import { catchError, filter, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { SideMenuService } from '@services/sidemenu.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SidebarToggleService } from '../sidebar-toggle.service';
import { resolveMenuUrl } from '@/constants/constants';
// elevation-4
const BASE_CLASSES = '';
// main-sidebar 
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    // New white-sidebar revamp — remove the second entry below to revert to the old dark sidebar only.
    styleUrls: ['./menu-sidebar.component.scss', './menu-sidebar-revamp.scss']
})
export class MenuSidebarComponent implements OnInit, OnDestroy {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu = MENU;
    getList: any;
    userType: string;
    user_type: any
    userToken: any
    currentUrl: string;

    // new
    sideMenuItems: Array<any> = []
    private menuUpdateSubscription: Subscription;
    private routerEventsSubscription: Subscription;
    isLoadingMenu: boolean = false;

    constructor(
        public appService: AppService,
        public apiService: ApiService,
        private _utilityService: UtilityService,
        private store: Store<AppState>,
        private modalService: NgbModal,
        private activeRoute: Router,
        private sideMenu: SideMenuService,
        private sanitizer: DomSanitizer,
        private sidebarToggle: SidebarToggleService,
    ) {
        this.routerEventsSubscription = this.activeRoute.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.currentUrl = event.urlAfterRedirects;
                // Auto-hide the mobile off-canvas menu after navigating.
                // No-op on desktop, where the same class means "collapsed to
                // icon rail" instead and shouldn't react to routing.
                if (window.innerWidth < 768) {
                    this.sidebarToggle.close();
                }
                this.syncExpandedMenu();
            });
    }

    ngOnInit() {
        // Explicit guarantee that the mobile off-canvas menu starts closed,
        // rather than relying only on the CSS default — SidebarToggleService
        // is a root singleton, so its state can otherwise carry over from an
        // earlier SPA navigation instead of resetting.
        if (window.innerWidth < 768) {
            this.sidebarToggle.close();
        }

        // superuser_zc
        this.user = this.appService.loginUser;
        this.userToken = this.apiService.decodeAuth2();
        this.user_type = this.userToken.role

        this.getList = this._utilityService.decodeUserCode();

        this.userType = this.getList.role;
        localStorage.removeItem('sideMenu');

        // new
        this.menuUpdateSubscription = this.sideMenu.menuUpdated$.subscribe(() => {
            this.fetchSideMenu();
        })
        this.fetchSideMenu();
    }

    ngOnDestroy(): void {
        this.menuUpdateSubscription?.unsubscribe();
        this.routerEventsSubscription?.unsubscribe();
    }

    showPlantList() {
        this._utilityService.setUrl(false);
    }

    openEmailModal() {
        //debugger;
        const modalRef = this.modalService.open(EmailComponent);
        // You can pass data to the modal component if needed
        // modalRef.componentInstance.someData = data;
    }
    // isMainMenuActive(submenuUrls: string[]): boolean {
    //     if (submenuUrls.length === 1 && submenuUrls[0] === '/') {
    //         return this.currentUrl === '/';
    //     }

    //     return submenuUrls.some(url => this.currentUrl.includes(url));
    // }
    // The URL to match menu entries against: query string stripped, and
    // drill-down pages (plant detail, cluster) mapped onto the list entry
    // they belong to so that entry stays highlighted while you're in them.
    private get activeMenuUrl(): string {
        return resolveMenuUrl(this.currentUrl || this.activeRoute.url);
    }

    isMainMenuActive(submenuUrls: string[]): boolean {
        if (submenuUrls.length === 1 && submenuUrls[0] === '/') {
            return this.activeMenuUrl === '/';
        }
        return submenuUrls.some(url => this.matchesUrl(url));
    }

    // Whether a menu entry owns the current page — an exact match, or a
    // sub-route of it such as /help-desk/tickets/12.
    isChildActive(child: any): boolean {
        return this.matchesUrl(child?.url);
    }

    private matchesUrl(url: string): boolean {
        if (!url || url === '/') {
            return this.activeMenuUrl === '/';
        }
        const current = this.activeMenuUrl;
        return current === url || current.startsWith(url + '/');
    }

    // Add this new method
    isMenuItemActive(item: any): boolean {
        if (!item.children || item.children.length === 0) {
            return false;
        }
        const childUrls = item.children.map((child: any) => child.url);
        return this.isMainMenuActive(childUrls);
    }
    fetchSideMenu(): void {
        this.isLoadingMenu = true; // Add this line
        this.sideMenu.fetchSideMenu().pipe(
            tap((response) => {
                if (response) {

                    const hasViewPermission = (item: any): boolean => {
                        if (item.canView) {
                            return true;
                        }
                        if (item.children && item.children.length > 0) {
                            return item.children.some(hasViewPermission);
                        }
                        return false;
                    };

                    // Filter based on permissions
                    this.sideMenuItems = response
                        .filter((item: any) => hasViewPermission(item))
                        .map((item: any) => {
                            return {
                                ...item,
                                icon: this.sanitizer.bypassSecurityTrustHtml(item.icon),
                                isExpanded: false,
                                openInNewTab: false,
                                url: item.url
                            };
                        });
                    this.saveToLocal(this.sideMenuItems)
                } else {
                    this.sideMenuItems = [];
                }
                this.isLoadingMenu = false; // Add this line
                this.syncExpandedMenu();
            }),
            catchError((err: HttpErrorResponse) => {
                console.log('error:', err.error.message);
                this.isLoadingMenu = false; // Add this line
                return of(undefined);
            })
        ).subscribe();
    }
    saveToLocal(menu: any) {
        const menuString = JSON.stringify(menu)
        localStorage.setItem('sideMenu', menuString)
    }

    // Expands the sidebar category that owns the current route and collapses
    // any other open one, keeping the dropdown's "show" class in sync with
    // its trigger's aria-expanded (and so the arrow icon, which is driven
    // purely off aria-expanded in app.css). Done imperatively, once per
    // menu-load/navigation, instead of via a persistent Angular binding —
    // a binding re-asserted on every change detection run would fight
    // Bootstrap's own click-driven open/close and leave the arrow stuck.
    private syncExpandedMenu(): void {
        setTimeout(() => {
            const container = document.getElementById('navbar-nav');
            if (!container) {
                return;
            }
            const activeItem = this.sideMenuItems.find((item: any) => this.isMenuItemActive(item));
            const activeTargetId = activeItem ? 'sidebar' + activeItem.id : null;

            container.querySelectorAll<HTMLElement>('.menu-dropdown.show').forEach((panel) => {
                if (panel.id !== activeTargetId) {
                    panel.classList.remove('show');
                    container.querySelector(`[aria-controls="${panel.id}"]`)
                        ?.setAttribute('aria-expanded', 'false');
                }
            });

            if (activeTargetId) {
                document.getElementById(activeTargetId)?.classList.add('show');
                container.querySelector(`[aria-controls="${activeTargetId}"]`)
                    ?.setAttribute('aria-expanded', 'true');
            }
        });
    }
}

export const MENU = [
    {
        name: 'Dashboard',
        iconClasses: 'fas fa-tachometer-alt',
        path: ['/']
    },
    {
        name: 'Plants',
        iconClasses: 'ion-social-windows-outline',
        path: ['/plants']
    },

];
